import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import useAuth from "./hooks/useAuth";
import { InactivityProvider } from "./Context/InactivityProvider";
import Preloader from "./shared/PreLoaders";
import Dashboard from "./dashboard/Dashboard";

import Login from "./user-pages/Login";

import Lockscreen from "./user-pages/Lockscreen";

import State from "./components/State/State";
import Circle from "./components/Circle/Circle";
import Division from "./components/Division/Division";
import Range from "./components/Range/Range";
import ManageVFC from "./components/VFC/Manage";
import AddVFC from "./components/VFC/AddVFC";
import EditVFC from "./components/VFC/EditVFC";
import VFCDashboard from "./components/VFC/Components/VFCDashboard";
import VfcDetails from "./components/modals/VfcDetails";
import VFCProfile from "./components/VFC/Components/VFCProfile";
import VFCBasicReports from "./components/VFC/Components/VFCBasicReports";

import UpdateRenewalandAudit from "./components/VFC/UpdateRenewalandAudit";

import ManageMember from "./components/Member/ManageMember";
import AddMember from "./components/Member/AddMember";
import MemberProfile from "./components/Member/MemberProfile";
import UpdateDesignation from "./components/Member/UpdateDesignation";

import EditMember from "./components/Member/EditMember";

import AddSHG from "./components/SHG/AddSHG";
import SHGProfile from "./components/SHG/Component/SHGProfile";
import ManageSHG from "./components/SHG/ManageSHG";
import EditShg from "./components/SHG/EditSHG";
import JoinSHG from "./components/SHG/JoinSHG";
import ManageShgMember from "./components/SHG/ManageShgMember";
import EditShgMember from "./components/SHG/EditShgMember";
import NewLoan from "./components/Loan/NewLoan";
import ManageLoan from "./components/Loan/ManageLoan";
import LoanRepayments from "./components/Loan/LoanRepayments";
import ManageLoanRepayment from "./components/Loan/ManageLoanRepayment";

import ViewBill from "./components/Loan/Components/ViewBill";
import Interst from "./components/Intrest/Intrest";
import DailyLoanReport from "./components/Loan/Components/DailyLoanReport";

import Installment from "./components/Installment/ManageInstallment";

import LoanType from "./components/LoanType/LoanType";
import Accounts from "./components/Vouchers/Accounts/Accounts";
import VoucherType from "./components/Vouchers/VoucherType/VoucherType";

import VoucherTypeMapping from "./components/Vouchers/VoucherType/VoucherTypeMapping";

import AddReceipt from "./components/Transactions/Receipt/AddReceipt";

import TransactionProfile from "./components/Transactions/TransactionProfile";

import ManageReceipt from "./components/Transactions/Receipt/ManageReceipt";

import EditReceipt from "./components/Transactions/Receipt/EditReceipt";

import ViewReceipt from "./components/Transactions/Receipt/ViewReceipt";

import AddPayments from "./components/Transactions/Payments/AddPayments";

import ManagePayments from "./components/Transactions/Payments/ManagePayments";

import EditPayments from "./components/Transactions/Payments/EditPayments";

import ViewPayments from "./components/Transactions/Payments/ViewPayments";
import Cashbook from "./components/CashBook/Cashbook";
import ManagePermission from "./components/UserComponent/Permissions/ManagePermission";
import ManageRole from "./components/UserComponent/Role/ManageRole";
import ManageUser from "./components/UserComponent/User/ManageUser";
import Access from "./components/UserComponent/User/Access";
import AddDocument from "./components/Documents/AddDocument";
import ViewDocument from "./components/Documents/ViewDocument";
import EditDocument from "./components/Documents/EditDocument";
import AddGO from "./components/Documents/GovtOrders/AddGO";
import ViewGO from "./components/Documents/GovtOrders/ViewGO";
import VFCCollaboration from "./components/VFC/Components/VFCCollaboration";
import VFCDash from "./components/VFCDash";
import ActivityLog from "./utils/ActivityLog";
import ForgotPassword from "./user-pages/ForgotPassword";
import LoanApplications from "./components/Loan/Components/LoanApplications";
import VFCStatus from "./components/VFC/Components/VFCStatus";
import RenewalFormat from "./components/VFC/Components/RenewalFormat";
import RangeReport from "./components/Range/RangeReport";
import PrivacyPolicy from "./shared/PrivacyPolicy";
import DivisionVFCPage from "./components/modals/VFCDrillDown/DivisionVFCPage";
import RangeVFCPage from "./components/modals/VFCDrillDown/RangeVFCPage";
import VFCDetailsPage from "./components/modals/VFCDrillDown/VFCDetailsPage";
import CircleVFCPage from "./components/modals/VFCDrillDown/CircleVFCpage";
import VFCMembers from "./components/modals/VfcMembersDrillDown/VFCMembers";
import SingleVfcMember from "./components/modals/VfcMembersDrillDown/SingleVfcMember";
import CircleVfcMembers from "./components/modals/VfcMembersDrillDown/CircleVfcMembers";
import CircleMemberPage from "./components/modals/VfcMembersDrillDown/CircleMemberPage";
import DivisionMembersPage from "./components/modals/VfcMembersDrillDown/DivisionMembersPage";
import RangeMembersPage from "./components/modals/VfcMembersDrillDown/RangeMembersPage";
import ShgPage from "./components/modals/SHGDrillDown/ShgPage";
import CircleShgPage from "./components/modals/SHGDrillDown/CircleShgPage";
import DivisionSHGpage from "./components/modals/SHGDrillDown/DivisionSHGpage";
import RangeShgPage from "./components/modals/SHGDrillDown/RangeShgPage";
import ShgDetails from "./components/modals/SHGDrillDown/ShgDetails";
import ShgMainPage from "./components/modals/SHGMemberDrillDown/ShgMainPage";
import CircleShgMemberPage from "./components/modals/SHGMemberDrillDown/CircleShgMemberPage";
import DivisionShgMemberPage from "./components/modals/SHGMemberDrillDown/DivisionShgMemberPage";
import RangeShgMembers from "./components/modals/SHGMemberDrillDown/RangeShgMembers";
import ShgMembersPage from "./components/modals/SHGMemberDrillDown/ShgMembersPage";
import SingleShgMemberPage from "./components/modals/SHGMemberDrillDown/SingleShgMemberPage";
import LoanFirstPage from "./components/modals/LoanDrillDown/LoanFirstPage";
import CircleLoanPage from "./components/modals/LoanDrillDown/CircleLoanPage";
import DivisionLoanPage from "./components/modals/LoanDrillDown/DivisionLoanPage";
import RangeLoanPage from "./components/modals/LoanDrillDown/RangeLoanPage";
import VFCLoansPage from "./components/modals/LoanDrillDown/VFCLoansPage";

const AppRoutes = () => {
  const { permissions } = useAuth();

  return (
    <Suspense fallback={<Preloader />}>
      <InactivityProvider>
        <Routes>
          <Route path="/login-1" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/user-pages/lockscreen" element={<Lockscreen />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/vfcdash" element={<VFCDash />} />
          <Route exact path="/privacyPolicy" element={<PrivacyPolicy />} />
          {permissions.includes("ManageState") && (
            <Route
              path="state"
              element={
                <PrivateRoute requiredPermissions={["ManageState"]}>
                  <State />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageCircle") && (
            <Route
              path="circle"
              element={
                <PrivateRoute requiredPermissions={["ManageCircle"]}>
                  <Circle />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageDivision") && (
            <Route
              path="division"
              element={
                <PrivateRoute requiredPermissions={["ManageDivision"]}>
                  <Division />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageRange") && (
            <Route
              path="range"
              element={
                <PrivateRoute requiredPermissions={["ManageRange"]}>
                  <Range />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageRange") && (
            <Route
              path="range/report"
              element={
                <PrivateRoute requiredPermissions={["ManageRange"]}>
                  <RangeReport />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageVfc") && (
            <Route
              path="vfc/manage"
              element={
                <PrivateRoute requiredPermissions={["ManageVfc"]}>
                  <ManageVFC />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("VfcProfile") && (
            <Route
              path="vfc/profile"
              element={
                <PrivateRoute requiredPermissions={["VfcProfile"]}>
                  <VFCProfile />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("VfcDashboard") && (
            <Route
              path="vfc/dashboard"
              element={
                <PrivateRoute requiredPermissions={["VfcDashboard"]}>
                  <VFCDashboard />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("VfcDashboard") && (
            <Route
              path="vfc/Status"
              element={
                <PrivateRoute requiredPermissions={["VfcDashboard"]}>
                  <VFCStatus />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("VfcDashboard") && (
            <Route
              path="vfc/Renewal"
              element={
                <PrivateRoute requiredPermissions={["VfcDashboard"]}>
                  <RenewalFormat />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("UpdateVFC&Audit") && (
            <Route
              path="vfc/update/renewal"
              element={
                <PrivateRoute requiredPermissions={["UpdateVFC&Audit"]}>
                  <UpdateRenewalandAudit />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("VfcCollab") && (
            <Route
              path="vfc/collaboration"
              element={
                <PrivateRoute requiredPermissions={["VfcCollab"]}>
                  <VFCCollaboration />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("VFCBasicReport") && (
            <Route
              path="vfc/basic/report"
              element={
                <PrivateRoute requiredPermissions={["VFCBasicReport"]}>
                  <VFCBasicReports />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddVfc") && (
            <Route
              path="vfc/add"
              element={
                <PrivateRoute requiredPermissions={["AddVfc"]}>
                  <AddVFC />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddVfc") && (
            <Route
              path="vfc/manage/vfc/add"
              element={
                <PrivateRoute requiredPermissions={["AddVfc"]}>
                  <AddVFC />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageVfc") && (
            <Route
              path="/drill/vfc-in-details"
              element={
                <PrivateRoute requiredPermissions={["ManageVfc"]}>
                  <VfcDetails />
                </PrivateRoute>
              }
            />
          )}

          {permissions.includes("EditVfc") && (
            <Route
              path="vfc/manage/edit/:id"
              element={
                <PrivateRoute requiredPermissions={["EditVfc"]}>
                  <EditVFC />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddMember") && (
            <Route
              path="member/add"
              element={
                <PrivateRoute requiredPermissions={["AddMember"]}>
                  <AddMember />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddMember") && (
            <Route
              path="member/manage/member/add"
              element={
                <PrivateRoute requiredPermissions={["AddMember"]}>
                  <AddMember />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageMember") && (
            <Route
              path="member/manage"
              element={
                <PrivateRoute requiredPermissions={["ManageMember"]}>
                  <ManageMember />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("MemberProfile") && (
            <Route
              path="member/profile"
              element={
                <PrivateRoute requiredPermissions={["MemberProfile"]}>
                  <MemberProfile />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("UpdateDesignation") && (
            <Route
              path="member/update/designation"
              element={
                <PrivateRoute requiredPermissions={["UpdateDesignation"]}>
                  <UpdateDesignation />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("EditMember") && (
            <Route
              path="member/manage/edit/:id"
              element={
                <PrivateRoute requiredPermissions={["EditMember"]}>
                  <EditMember />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddSHG") && (
            <Route
              path="SHG/add"
              element={
                <PrivateRoute requiredPermissions={["AddSHG"]}>
                  <AddSHG />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("SHGProfile") && (
            <Route
              path="SHG/profile"
              element={
                <PrivateRoute requiredPermissions={["SHGProfile"]}>
                  <SHGProfile />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageSHG") && (
            <Route
              path="/SHG/manage"
              element={
                <PrivateRoute requiredPermissions={["ManageSHG"]}>
                  <ManageSHG />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddSHG") && (
            <Route
              path="SHG/manage/SHG/add"
              element={
                <PrivateRoute requiredPermissions={["AddSHG"]}>
                  <AddSHG />
                </PrivateRoute>
              }
            />
          )}

          {permissions.includes("EditSHG") && (
            <Route
              path="SHG/manage/edit/:id"
              element={
                <PrivateRoute requiredPermissions={["EditSHG"]}>
                  <EditShg />
                </PrivateRoute>
              }
            />
          )}

          {permissions.includes("JoinSHG") && (
            <Route
              path="SHG/join"
              element={
                <PrivateRoute requiredPermissions={["JoinSHG"]}>
                  <JoinSHG />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageSHGMember") && (
            <Route
              path="SHG/member/manage"
              element={
                <PrivateRoute requiredPermissions={["ManageSHGMember"]}>
                  <ManageShgMember />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("EditShgMember") && (
            <Route
              path="manage/shg/member/edit/:id"
              element={
                <PrivateRoute requiredPermissions={["EditShgMember"]}>
                  <EditShgMember />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("NewLoan") && (
            <Route
              path="loan/new"
              element={
                <PrivateRoute requiredPermissions={["NewLoan"]}>
                  <NewLoan />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("NewLoan") && (
            <Route
              path="loan/new/applications"
              element={
                <PrivateRoute requiredPermissions={["NewLoan"]}>
                  <LoanApplications />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageLoan") && (
            <Route
              path="loan/manage"
              element={
                <PrivateRoute requiredPermissions={["ManageLoan"]}>
                  <ManageLoan />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("LoanRepayment") && (
            <Route
              path="loan/repayment"
              element={
                <PrivateRoute requiredPermissions={["LoanRepayment"]}>
                  <LoanRepayments />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageLoanRepayment") && (
            <Route
              path="loan/epayment/manage"
              element={
                <PrivateRoute requiredPermissions={["ManageLoanRepayment"]}>
                  <ManageLoanRepayment />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ViewLoanBill") && (
            <Route
              path="loan/view/bill"
              element={
                <PrivateRoute requiredPermissions={["ViewLoanBill"]}>
                  <ViewBill />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageIntrest") && (
            <Route
              path="intrest"
              element={
                <PrivateRoute requiredPermissions={["ManageIntrest"]}>
                  <Interst />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageLoanType") && (
            <Route
              path="type/loan"
              element={
                <PrivateRoute requiredPermissions={["ManageLoanType"]}>
                  <LoanType />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageAccount") && (
            <Route
              path="vouchers/accounts"
              element={
                <PrivateRoute requiredPermissions={["ManageAccount"]}>
                  <Accounts />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageVoucherType") && (
            <Route
              path="vouchers/type"
              element={
                <PrivateRoute requiredPermissions={["ManageVoucherType"]}>
                  <VoucherType />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageVoucherTypeMappings") && (
            <Route
              path="vouchers/type/mappings"
              element={
                <PrivateRoute
                  requiredPermissions={["ManageVoucherTypeMappings"]}
                >
                  <VoucherTypeMapping />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddReceipt") && (
            <Route
              path="transaction/add/receipt"
              element={
                <PrivateRoute requiredPermissions={["AddReceipt"]}>
                  <AddReceipt />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("TransactionProfile") && (
            <Route
              path="transaction/profile"
              element={
                <PrivateRoute requiredPermissions={["TransactionProfile"]}>
                  <TransactionProfile />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddReceipt") && (
            <Route
              path="manage/receipt/add/receipt"
              element={
                <PrivateRoute requiredPermissions={["AddReceipt"]}>
                  <AddReceipt />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageReceipt") && (
            <Route
              path="transaction/manage/receipt"
              element={
                <PrivateRoute requiredPermissions={["ManageReceipt"]}>
                  <ManageReceipt />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("EditReceipt") && (
            <Route
              path="manage/receipt/edit/:id"
              element={
                <PrivateRoute requiredPermissions={["EditReceipt"]}>
                  <EditReceipt />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ViewReceipt") && (
            <Route
              path="transaction/view/receipt"
              element={
                <PrivateRoute requiredPermissions={["ViewReceipt"]}>
                  <ViewReceipt />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddPayments") && (
            <Route
              path="transaction/add/payments"
              element={
                <PrivateRoute requiredPermissions={["AddPayments"]}>
                  <AddPayments />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManagePayments") && (
            <Route
              path="transaction/manage/payments"
              element={
                <PrivateRoute requiredPermissions={["ManagePayments"]}>
                  <ManagePayments />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("EditPayments") && (
            <Route
              path="manage/payments/edit/:id"
              element={
                <PrivateRoute requiredPermissions={["EditPayments"]}>
                  <EditPayments />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ViewPayments") && (
            <Route
              path="transaction/view/payment"
              element={
                <PrivateRoute requiredPermissions={["ViewPayments"]}>
                  <ViewPayments />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("Cashbook") && (
            <Route
              path="cashbook"
              element={
                <PrivateRoute requiredPermissions={["Cashbook"]}>
                  <Cashbook />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManagePermissions") && (
            <Route
              path="user/permission"
              element={
                <PrivateRoute requiredPermissions={["ManagePermissions"]}>
                  <ManagePermission />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageRole") && (
            <Route
              path="user/role"
              element={
                <PrivateRoute requiredPermissions={["ManageRole"]}>
                  <ManageRole />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageUser") && (
            <Route
              path="user/manage"
              element={
                <PrivateRoute requiredPermissions={["ManageUser"]}>
                  <ManageUser />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddAccess") && (
            <Route
              path="user/access"
              element={
                <PrivateRoute requiredPermissions={["AddAccess"]}>
                  <Access />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddDocs") && (
            <Route
              path="document/add"
              element={
                <PrivateRoute requiredPermissions={["AddDocs"]}>
                  <AddDocument />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ViewDocs") && (
            <Route
              path="document/view"
              element={
                <PrivateRoute requiredPermissions={["ViewDocs"]}>
                  <ViewDocument />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("EditDocs") && (
            <Route
              path="document/edit"
              element={
                <PrivateRoute requiredPermissions={["EditDocs"]}>
                  <EditDocument />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("AddGovtDocs") && (
            <Route
              path="document/govt/add"
              element={
                <PrivateRoute requiredPermissions={["AddGovtDocs"]}>
                  <AddGO />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ViewGovtDocs") && (
            <Route
              path="document/govt/view"
              element={
                <PrivateRoute requiredPermissions={["ViewGovtDocs"]}>
                  <ViewGO />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("ManageInstallment") && (
            <Route
              path="intrest/installment"
              element={
                <PrivateRoute requiredPermissions={["ManageInstallment"]}>
                  <Installment />
                </PrivateRoute>
              }
            />
          )}
          {permissions.includes("DailyLoanReport") && (
            <Route
              path="loan/report/daily"
              element={
                <PrivateRoute requiredPermissions={["DailyLoanReport"]}>
                  <DailyLoanReport />
                </PrivateRoute>
              }
            />
          )}

          <Route
            path="/activity-log"
            element={
              <PrivateRoute>
                <ActivityLog />
              </PrivateRoute>
            }
          />

          {/* vfc drill down pages */}
          <Route
            path="/drill/circle-vfc/:circleId"
            element={<CircleVFCPage />}
          />

          <Route
            path="/drill/division-vfc/:divisionId"
            element={<DivisionVFCPage />}
          />
          <Route path="/drill/range/:rangeId" element={<RangeVFCPage />} />

          <Route path="/drill/vfc/:vfcId" element={<VFCDetailsPage />} />

          {/* Member drill down pages */}

          <Route path="/drill/circle/member" element={<CircleVfcMembers />} />
          <Route
            path="/drill/circle-member/:circleId"
            element={<CircleMemberPage />}
          />
          <Route
            path="/drill/division-member/:divisionId"
            element={<DivisionMembersPage />}
          />
          <Route
            path="/drill/range-members/:rangeId"
            element={<RangeMembersPage />}
          />
          <Route
            path="/drill/single/members/:memberId"
            element={<SingleVfcMember />}
          />
          <Route path="/drill/members/:vfcId" element={<VFCMembers />} />

          {/* SHG drill down pages */}
          <Route path="/drill/circle/SHG" element={<ShgPage />} />

          <Route
            path="/drill/circle-shg/:circleId"
            element={<CircleShgPage />}
          />
          <Route
            path="/drill/division-shg/:divisionId"
            element={<DivisionSHGpage />}
          />
          <Route path="/drill/range-shg/:rangeId" element={<RangeShgPage />} />

          <Route path="/drill/Shg/:shgId" element={<ShgDetails />} />

          {/*SHG Member DrillDown Pages */}

          <Route path="/drill/SHG/member" element={<ShgMainPage />} />
          <Route
            path="/drill/circle-Shg-member/:circleId"
            element={<CircleShgMemberPage />}
          />
          <Route
            path="/drill/division-Shg-member/:divisionId"
            element={<DivisionShgMemberPage />}
          />
          <Route
            path="/drill/range-Shg-members/:rangeId"
            element={<RangeShgMembers />}
          />
          <Route
            path="/drill/single-shg/members/:memberId"
            element={<SingleShgMemberPage />}
          />
          <Route
            path="/drill/Shg-members/:shgId"
            element={<ShgMembersPage />}
          />

          {/* Loan Drilldown Pages */}
          <Route path="/drill/loans" element={<LoanFirstPage />} />

          <Route
            path="/drill/circle-loans/:circleId"
            element={<CircleLoanPage />}
          />
          <Route
            path="/drill/division-loans/:divisionId"
            element={<DivisionLoanPage />}
          />
          <Route
            path="/drill/range-loans/:rangeId"
            element={<RangeLoanPage />}
          />
          <Route path="/drill/vfc-loans/:vfcId" element={<VFCLoansPage />} />
        </Routes>
      </InactivityProvider>
    </Suspense>
  );
};

export default AppRoutes;
